
export { WelcomePage as default } from '../../views/pages/WelcomePage'
